import React, { PureComponent } from "react";
import { Col } from "reactstrap";
import { Field, reduxForm } from "redux-form";
import PropTypes from "prop-types";
import ReactTags from "react-tag-autocomplete";

class HorizontalForm extends PureComponent {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
  };

  state = {
    name: "",
    email: "",
    roles: [],
    meeting_link: "",
    bio: "",
    contact_number: "",
    timezone: "",
    organization_role: "",
  };

  componentDidMount() {
    if (this.props.edit.aid !== undefined && this.props.edit.aid > 0) {
      this.props.initialize(this.props.edit);
      delete this.props.edit.roles;

      this.setState(
        {
          aid: this.props.edit.aid,
          name: this.props.edit.name !== null ? this.props.edit.name : "",
          email: this.props.edit.email !== null ? this.props.edit.email : "",
          meeting_link:
            this.props.edit.meeting_link !== null
              ? this.props.edit.meeting_link
              : "",
          bio: this.props.edit.bio !== null ? this.props.edit.bio : "",
          contact_number:
            this.props.edit.contact_number !== null
              ? this.props.edit.contact_number
              : "",
          timezone:
            this.props.edit.timezone !== null ? this.props.edit.timezone : "",
          organization_role:
            this.props.edit.organization_role !== null
              ? this.props.edit.organization_role
              : "",
        },
        () => this.props.handleForm(this.state)
      );
    }

    this.inputRef = React.createRef();
  }

  cancelCreation = () => {
    this.props.reset();
    this.props.cancelCreation();
  };

  formChangeHandler = (event) => {
    let nam = event.target.name;
    let val = event.target.value;

    this.setState({ [nam]: val }, () => {
      this.props.handleForm(this.state);
    });
  };

  onDelete(i) {
    const roles = this.state.roles.slice(0);
    roles.splice(i, 1);

    this.setState({ roles }, () => {
      this.props.handleForm(this.state);
    });
  }

  onAddition(role) {
    const roles = [].concat(this.state.roles, role);
    this.setState({ roles }, () => {
      this.props.handleForm(this.state);
    });
  }

  render() {
    const { handleSubmit } = this.props;

    return (
      <Col md={12} lg={12}>
        <div className="card__title">
          <h5 className="bold-text">{this.props.title}</h5>
        </div>
        <form
          autoComplete="off"
          className="form form--horizontal"
          onSubmit={handleSubmit}
        >
          {!this.props.setPassword ? (
            <React.Fragment>
              <div className="form__form-group">
                <span className="form__form-group-label">Full Name</span>
                <div className="form__form-group-field">
                  <Field
                    name="name"
                    component="input"
                    type="text"
                    placeholder="Full name"
                    onKeyUp={this.formChangeHandler}
                  />
                </div>
              </div>
              {this.props.edit.aid !== undefined && this.props.edit.aid > 0 ? (
                ""
              ) : (
                <React.Fragment>
                  <div className="form__form-group">
                    <span className="form__form-group-label">E-mail</span>
                    <div className="form__form-group-field">
                      <Field
                        name="email"
                        component="input"
                        type="email"
                        placeholder="Email address"
                        onKeyUp={this.formChangeHandler}
                      />
                    </div>
                  </div>
                  <div className="form__form-group">
                    <span className="form__form-group-label">Roles</span>
                    <div className="form__form-group-field">
                      <ReactTags
                        ref={this.inputRef}
                        tags={this.state.roles}
                        suggestions={this.props.roles}
                        onDelete={this.onDelete.bind(this)}
                        onAddition={this.onAddition.bind(this)}
                        placeholderText="Assign Role"
                      />
                    </div>
                  </div>
                </React.Fragment>
              )}

              <div className="form__form-group">
                <span className="form__form-group-label">Meeting link</span>
                <div className="form__form-group-field">
                  <Field
                    name="meeting_link"
                    component="input"
                    type="text"
                    placeholder="Meeting link"
                    onKeyUp={this.formChangeHandler}
                  />
                </div>
              </div>
              <div className="form__form-group">
                <span className="form__form-group-label">Contact Number</span>
                <div className="form__form-group-field">
                  <Field
                    name="contact_number"
                    component="input"
                    type="text"
                    placeholder="Contact Number"
                    onKeyUp={this.formChangeHandler}
                  />
                </div>
              </div>
              <div className="form__form-group">
                <span className="form__form-group-label">Timezone</span>
                <div className="form__form-group-field">
                  <Field
                    name="timezone"
                    component="input"
                    type="text"
                    placeholder="Timezone"
                    onKeyUp={this.formChangeHandler}
                  />
                </div>
              </div>
              <div className="form__form-group">
                <span className="form__form-group-label">Role</span>
                <div className="form__form-group-field">
                  <Field
                    name="organization_role"
                    component="input"
                    type="text"
                    placeholder="Organization Role"
                    onKeyUp={this.formChangeHandler}
                  />
                </div>
              </div>
              <div className="form__form-group">
                <span className="form__form-group-label">Bio</span>
                <div className="form__form-group-field">
                  <Field
                    name="bio"
                    component="textarea"
                    type="textarea"
                    placeholder="Bio"
                    onKeyUp={this.formChangeHandler}
                  />
                </div>
              </div>
            </React.Fragment>
          ) : (
            ""
          )}

          {this.props.setPassword ? (
            <React.Fragment>
              <div className="form__form-group">
                <span className="form__form-group-label">Password</span>
                <div className="form__form-group-field">
                  <Field
                    name="password"
                    component="input"
                    type="password"
                    placeholder="Password"
                    onKeyUp={this.formChangeHandler}
                  />
                </div>
              </div>
              <div className="form__form-group">
                <span className="form__form-group-label">Confirm Password</span>
                <div className="form__form-group-field">
                  <Field
                    name="confirm_password"
                    component="input"
                    type="password"
                    placeholder="Confirm Password"
                    onKeyUp={this.formChangeHandler}
                  />
                </div>
              </div>
            </React.Fragment>
          ) : (
            ""
          )}
        </form>
      </Col>
    );
  }
}

export default reduxForm({
  form: "invite_team_form", // a unique identifier for this form
})(HorizontalForm);
